export default __webpack_public_path__ + "static/media/slider-info-laptop-image1.36ef3b26.jpg";